import React, { useEffect } from 'react'
import Donate from './Donate'
import { Grid } from '@mui/material'
import Donatebcontent from './Donatebcontent'
import Header from '../../../common/Header'
import FooterInnerPagee from '../../../common/FooterInnerPagee'
import PhilanthropySection from './PhilanthropySection'
import FoundationsCarousel from './FoundationsCarousel'

const DonateHomePage = () => {

    useEffect(()=>{
        window.scroll(0,0);
    },[])

    
    return (
        <>
        <Header/>
            <Grid>
                <Donate />
                <Donatebcontent />
                <PhilanthropySection/>
                <FoundationsCarousel/>
            </Grid>
            <FooterInnerPagee/>
        </>
    )

}

export default DonateHomePage